import { NavigationGuard } from 'vue-router';
import { configurationModule, ConfigurationState } from '@/store/modules/configuration';
import { RouteNames } from '@/utils/router/router.models';
import { tRoute } from '../plugins/i18nRoutes';

export const emptyConfigurationGuard: NavigationGuard = async (to, from, next) => {
  // Check if navigation was outside of the app
  // and navigation route isn't Home but configuration doesn't exist
  if (
    !from.matched.length &&
    !(configurationModule.state as ConfigurationState)?.houseConfiguration &&
    to.name !== tRoute(RouteNames.Home).name &&
    to.name !== RouteNames.Code &&
    to.name !== RouteNames.MobileHome
  ) {
    next(tRoute(RouteNames.Home));
  } else {
    next();
  }
};
